/**
 * Filters out properties from an object that end with a specific string
 * @param {Object} obj - The object to filter
 * @param {string} filterStr - The string to filter by (matches end of key)
 * @returns {Object} New object with filtered keys removed
 */
export const filterObjectKeysBySuffix = (obj, filterStr) => (
  Object.keys(obj).reduce((accu, key) => {
    if (!key.endsWith(filterStr)) {
      accu[key] = obj[key];
    }
    return accu;
  }, {})
);
